import { auth } from '../../firebase';

const API_URL = import.meta.env.VITE_ADMIN_URL || "";

/**
 * Obtener configuración de notificaciones para una sucursal
 * @param {string} sucursal - Nombre de la sucursal
 * @returns {Promise<Object>} Configuración de notificaciones
 */
export async function obtenerConfiguracionNotificaciones(sucursal) {
  const token = await auth.currentUser.getIdToken(true);
  const res = await fetch(`${API_URL}/configuracion/notificaciones?sucursal=${sucursal}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!res.ok) {
    throw new Error('Error al obtener configuración');
  }
  
  const data = await res.json();
  return data.info || {};
}

/**
 * Actualizar configuración de notificaciones
 * @param {Object} configuracion - Configuración a guardar
 * @returns {Promise<boolean>} true si se guardó correctamente
 */
export async function actualizarConfiguracionNotificaciones(configuracion) {
  const token = await auth.currentUser.getIdToken(true);
  const res = await fetch(`${API_URL}/configuracion/notificaciones`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(configuracion)
  });
  
  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.error || 'Error al guardar configuración');
  }
  
  return true;
}

/**
 * Listar todas las configuraciones de notificaciones
 * @returns {Promise<Array>} Lista de configuraciones
 */
export async function listarTodasConfiguracionesNotificaciones() {
  const token = await auth.currentUser.getIdToken(true);
  const res = await fetch(`${API_URL}/configuracion/notificaciones/todas`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!res.ok) {
    throw new Error('Error al listar configuraciones');
  }
  
  const data = await res.json();
  return data.info || [];
}